import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import axios from "axios";
import * as XLSX from "xlsx";
import Header from "../ReusedComponents/Header";
import { DecryptED } from "../../DecryptJS/Decrypt";

export default function TicketReport({ props }) {
  const history = useHistory();
  const { sid, uid } = useParams();

  const [data, setData] = useState([]);
  //const [userName, setUserName] = useState("");
  const [userName, setUserName] = useState("");
  const [viewMode, setViewMode] = useState("kanban");

  // Right panel
  const [selectedTicket, setSelectedTicket] = useState(null);

  // Filters
  const [filterStatus, setFilterStatus] = useState("Open");
  const [filterSchool, setFilterSchool] = useState("All");
  const [filterDateFrom, setFilterDateFrom] = useState("");
  const [filterDateTo, setFilterDateTo] = useState("");

  useEffect(() => {
    axios({
      url: "https://marcopolo.prisms.in/api/tickets/user/report",
      method: "POST",
      data: { sid: DecryptED(sid), uid: DecryptED(uid) },
    }).then((res) => {
      setData(res.data || []);
    });

    axios({
      url: "https://topschool.prisms.in/rest/index.php/user_list.json?",
      method: "POST",
      data: {
        fun_name: "AUserInfo",   // ✅ REQUIRED
        sid: DecryptED(sid),
        u_id: DecryptED(uid),   // ⚠️ must be u_id (not uid)
      },
    })
      .then((res) => {
        console.log("USER API 👉", res.data);

        const d = res.data || {};

        let name = "";

        if (d.student && d.student.length > 0) {
          name = d.student[0].name;
        } else if (d.name) {
          name = d.name;
        } else {
          name = "User";
        }

        setUserName(name);
      })
      .catch((err) => {
        console.log("ERROR ❌", err);
        setUserName("User");
      });
  }, [sid, uid]);

  const open = data.filter((d) => d.status === "Open");
  //const progress = data.filter((d) => d.status === "In Progress");
  const closed = data.filter((d) => d.status === "Closed");

  const schoolNames = [
    "All",
    ...new Set(
      data
        .map((d) => d.school_name || d.schoolName || d.school || "Unknown")
        .filter(Boolean)
    ),
  ];

  const filteredData = data.filter((d) => {
    const statusMatch = filterStatus === "All" || d.status === filterStatus;
    const schoolVal = d.school_name || d.schoolName || d.school || "Unknown";
    const schoolMatch = filterSchool === "All" || schoolVal === filterSchool;
    var dateMatch = true;
    const ticketDate = d.created_at || d.createdAt || d.date || "";
    if (filterDateFrom && ticketDate)
      dateMatch = dateMatch && new Date(ticketDate) >= new Date(filterDateFrom);
    if (filterDateTo && ticketDate)
      dateMatch = dateMatch && new Date(ticketDate) <= new Date(filterDateTo + "T23:59:59");
    return statusMatch && schoolMatch && dateMatch;
  });

  const resetFilters = () => {
    setFilterStatus("All");
    setFilterSchool("All");
    setFilterDateFrom("");
    setFilterDateTo("");
  };

  const statusColor = (s) => {
    if (s === "Open") return "#2563eb";
    //if (s === "In Progress") return "#d97706";
    if (s === "Closed") return "#16a34a";
    return "#6b7280";
  };

  const priorityColor = (p) => {
    if (!p) return "#6b7280";
    const v = p.toLowerCase();
    if (v === "high") return "#dc2626";
    if (v === "medium") return "#d97706";
    if (v === "low") return "#16a34a";
    return "#6b7280";
  };

  const detailUrl = (id) => "/tickets/user/details/" + sid + "/" + uid + "/" + id;

  const handleCardClick = (d) => {
    if (selectedTicket && selectedTicket.id === d.id) {
      history.push(detailUrl(d.id));
    } else {
      setSelectedTicket(d);
    }
  };

  const closePanel = () => setSelectedTicket(null);

  const exportToExcel = () => {
    var rows = filteredData.map((d) => ({
      "Ticket ID": "#" + d.id,
      "Title": d.title || "",
      "Description": d.description || "",
      "Status": d.status || "",
      "Priority": d.priority || "",
      "School": d.school_name || d.schoolName || d.school || "",
      "Assigned To": d.assigned_to || "",
      "Date": (d.created_at || d.createdAt || d.date)
        ? new Date(d.created_at || d.createdAt || d.date).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })
        : "",
    }));

    var ws = XLSX.utils.json_to_sheet(rows);
    ws["!cols"] = [
      { wch: 12 }, { wch: 30 }, { wch: 50 },
      { wch: 14 }, { wch: 12 }, { wch: 28 },
      { wch: 20 }, { wch: 16 },
    ];

    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Tickets");

    var today = new Date().toISOString().slice(0, 10);
    XLSX.writeFile(wb, "Ticket_Report_" + today + ".xlsx");
  };

  const formatDate = (raw) => {
    if (!raw) return "—";
    return new Date(raw).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <>
      <style>{`
        * { box-sizing: border-box; }

        .welcome-bar {
          background: #1e3a5f;
          color: #fff;
          padding: 10px 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 14px;
          font-family: 'Segoe UI', sans-serif;
        }
        .welcome-text { font-weight: 600; letter-spacing: 0.3px; }
        .welcome-name { color: #7dd3fc; margin-left: 4px; }

        .view-toggle-bar {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 10px 20px;
          background: #fff;
          border-bottom: 1px solid #dde1e7;
          font-family: 'Segoe UI', sans-serif;
        }
        .toggle-btn {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 7px 16px;
          border-radius: 6px;
          border: 1px solid #d1d5db;
          background: #fff;
          cursor: pointer;
          font-size: 13px;
          font-weight: 500;
          color: #374151;
          transition: all 0.15s;
        }
        .toggle-btn.active { background: #1e3a5f; color: #fff; border-color: #1e3a5f; }
        .toggle-btn:hover:not(.active) { background: #f3f4f6; }

        /* Main area: kanban + side panel side by side */
        .main-area {
          display: flex;
          font-family: 'Segoe UI', sans-serif;
          background: #f4f5f7;
          min-height: calc(100vh - 150px);
        }
        .board-area { flex: 1; min-width: 0; overflow: hidden; }

        /* Kanban */
        .kanban-board {
          display: flex;
          gap: 16px;
          padding: 16px;
          overflow-x: auto;
          min-height: calc(100vh - 150px);
        }
        .kanban-column {
          flex: 1;
          min-width: 240px;
          background: #ebecf0;
          border-radius: 10px;
          padding: 10px;
        }
        .kanban-col-header {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 10px;
        }
        .kanban-col-header h3 {
          font-size: 12px;
          font-weight: 700;
          margin: 0;
          color: #1e293b;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        .col-count {
          background: #c1c7d0;
          color: #42526e;
          border-radius: 10px;
          padding: 1px 7px;
          font-size: 11px;
          font-weight: 700;
        }
        .kanban-card {
          background: #fff;
          padding: 11px 12px;
          margin-bottom: 8px;
          border-radius: 8px;
          cursor: pointer;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
          border-left: 4px solid transparent;
          transition: transform 0.15s, box-shadow 0.15s, background 0.15s;
        }
        .kanban-card.selected { background: #eff6ff; box-shadow: 0 2px 8px rgba(37,99,235,0.18); }
        .kanban-card:hover { transform: translateY(-2px); box-shadow: 0 4px 10px rgba(0,0,0,0.13); }
        .kanban-card strong { display: block; font-size: 13px; color: #1e293b; margin-bottom: 4px; }
        .kanban-card p { font-size: 11px; color: #6b7280; margin: 0 0 6px 0; line-height: 1.4; }
        .card-footer { display: flex; justify-content: space-between; margin-top: 6px; font-size: 11px; }
        .card-id { color: #94a3b8; }
        .click-hint { font-size: 10px; color: #2563eb; margin-top: 5px; font-style: italic; }

        /* Right Detail Panel */
        .detail-panel {
          width: 340px;
          min-width: 300px;
          background: #fff;
          border-left: 1px solid #e2e8f0;
          box-shadow: -4px 0 20px rgba(0,0,0,0.08);
          display: flex;
          flex-direction: column;
          overflow-y: auto;
          max-height: calc(100vh - 150px);
          position: sticky;
          top: 0;
          animation: slideIn 0.22s ease;
        }
        @keyframes slideIn {
          from { transform: translateX(30px); opacity: 0; }
          to   { transform: translateX(0);    opacity: 1; }
        }
        .panel-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          padding: 14px 14px 10px;
          border-bottom: 1px solid #f1f5f9;
          background: #f8fafc;
        }
        .panel-header-left { flex: 1; min-width: 0; }
        .panel-ticket-id { font-size: 11px; color: #94a3b8; font-weight: 600; margin-bottom: 5px; }
        .panel-title-link {
          font-size: 14px;
          font-weight: 700;
          color: #1e3a5f;
          text-decoration: none;
          line-height: 1.4;
          display: block;
          cursor: pointer;
          border-bottom: 1px dashed #93c5fd;
          padding-bottom: 2px;
          transition: color 0.15s;
          word-break: break-word;
        }
        .panel-title-link:hover { color: #2563eb; text-decoration: none; }
        .panel-close {
          background: none;
          border: none;
          cursor: pointer;
          font-size: 17px;
          color: #94a3b8;
          padding: 0 2px;
          line-height: 1;
          transition: color 0.15s;
          flex-shrink: 0;
          margin-left: 8px;
        }
        .panel-close:hover { color: #374151; }
        .panel-body { padding: 14px; flex: 1; }
        .panel-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 11px;
        }
        .panel-label { color: #94a3b8; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; }
        .panel-value { color: #1e293b; font-size: 13px; font-weight: 500; text-align: right; }
        .panel-divider { border: none; border-top: 1px solid #f1f5f9; margin: 10px 0; }
        .panel-desc-label { font-size: 11px; font-weight: 600; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 6px; }
        .panel-desc { font-size: 12px; color: #374151; line-height: 1.6; background: #f8fafc; border-radius: 6px; padding: 9px; }
        .panel-open-btn {
          display: block;
          margin: 14px;
          padding: 9px;
          background: #1e3a5f;
          color: #fff;
          text-align: center;
          border-radius: 7px;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
          transition: background 0.15s;
        }
        .panel-open-btn:hover { background: #2563eb; }

        /* Badges */
        .status-badge {
          display: inline-block;
          padding: 2px 10px;
          border-radius: 12px;
          font-size: 11px;
          font-weight: 600;
          color: #fff;
          white-space: nowrap;
        }
        .priority-badge {
          display: inline-block;
          padding: 2px 10px;
          border-radius: 12px;
          font-size: 11px;
          font-weight: 600;
          color: #fff;
          white-space: nowrap;
        }

        /* Filter Bar */
        .filter-bar {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          align-items: center;
          padding: 10px 20px;
          background: #fff;
          border-bottom: 1px solid #e5e7eb;
          font-family: 'Segoe UI', sans-serif;
        }
        .filter-bar label { font-size: 12px; font-weight: 600; color: #6b7280; margin-right: 4px; }
        .filter-bar select, .filter-bar input[type="date"] {
          padding: 6px 10px;
          border: 1px solid #d1d5db;
          border-radius: 6px;
          font-size: 13px;
          color: #374151;
          background: #f9fafb;
          outline: none;
        }
        .filter-group { display: flex; align-items: center; gap: 5px; }
        .reset-btn {
          margin-left: auto;
          padding: 6px 14px;
          background: #fee2e2;
          color: #dc2626;
          border: 1px solid #fca5a5;
          border-radius: 6px;
          font-size: 12px;
          font-weight: 600;
          cursor: pointer;
        }
        .reset-btn:hover { background: #fecaca; }
        .export-btn {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 6px 16px;
          background: #16a34a;
          color: #fff;
          border: none;
          border-radius: 6px;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
          transition: background 0.15s;
          margin-left: 8px;
        }
        .export-btn:hover { background: #15803d; }

        /* List Table */
        .list-view-wrap { padding: 16px; overflow-x: auto; font-family: 'Segoe UI', sans-serif; background: #f4f5f7; min-height: calc(100vh - 150px); }
        .results-count { font-size: 13px; color: #6b7280; margin-bottom: 10px; }
        .ticket-table { width: 100%; border-collapse: collapse; background: #fff; border-radius: 10px; overflow: hidden; box-shadow: 0 1px 4px rgba(0,0,0,0.08); }
        .ticket-table thead tr { background: #1e3a5f; color: #fff; }
        .ticket-table th { padding: 11px 14px; text-align: left; font-size: 12px; font-weight: 600; letter-spacing: 0.5px; white-space: nowrap; }
        .ticket-table tbody tr { border-bottom: 1px solid #f1f5f9; transition: background 0.1s; }
        .ticket-table tbody tr:hover { background: #f0f7ff; }
        .ticket-table td { padding: 10px 14px; font-size: 13px; color: #374151; vertical-align: middle; }
        .ticket-title-link {
          color: #1e3a5f;
          font-weight: 600;
          cursor: pointer;
          border-bottom: 1px dashed #93c5fd;
          text-decoration: none;
        }
        .ticket-title-link:hover { color: #2563eb; }
        .empty-state { text-align: center; padding: 50px 20px; color: #9ca3af; font-size: 14px; }

        /* ===== MOBILE RESPONSIVE ===== */

        @media only screen and (max-width: 768px) {
          .welcome-bar {
            padding: 8px 12px;
            font-size: 12px;
            flex-wrap: wrap;
            gap: 4px;
          }
          .welcome-text { font-size: 13px; }
          .welcome-name { display: block; font-size: 13px; margin-left: 0; }

          .view-toggle-bar {
            padding: 8px 12px;
            gap: 8px;
          }
          .toggle-btn {
            padding: 6px 12px;
            font-size: 12px;
            flex: 1;
            justify-content: center;
          }

          .filter-bar {
            padding: 8px 12px;
            gap: 6px;
          }
          .filter-bar label { font-size: 11px; }
          .filter-bar select, .filter-bar input[type="date"] {
            padding: 6px 8px;
            font-size: 12px;
            flex: 1;
            min-width: 0;
          }
          .filter-group { flex: 1; min-width: 0; }
          .export-btn {
            padding: 6px 12px;
            font-size: 12px;
            margin-left: 0;
            width: 100%;
            justify-content: center;
          }
          .reset-btn {
            margin-left: 0;
            width: 100%;
            text-align: center;
          }
        }

        @media only screen and (max-width: 480px) {
          /* Kanban: stack columns vertically */
          .kanban-board {
            flex-direction: column;
            gap: 12px;
            padding: 10px;
            min-height: auto;
            overflow-x: hidden;
          }
          .kanban-column {
            min-width: unset;
            width: 100%;
            flex: unset;
          }
          .kanban-card {
            padding: 10px;
          }
          .kanban-card strong { font-size: 13px; }
          .kanban-card p { font-size: 11px; }
          .card-footer { font-size: 11px; }

          /* Main area: single column */
          .main-area {
            flex-direction: column;
            min-height: auto;
          }
          .board-area {
            width: 100%;
            overflow-x: hidden;
          }

          /* Detail panel: full width overlay */
          .detail-panel {
            width: 100% !important;
            min-width: unset !important;
            max-height: none;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 100;
            border-left: none;
            border-radius: 0;
          }
          .panel-header { padding: 12px; }
          .panel-body { padding: 12px; }
          .panel-open-btn { margin: 12px; }

          /* List Table: horizontal scroll */
          .list-view-wrap {
            padding: 10px;
          }
          .ticket-table {
            font-size: 12px;
            display: block;
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
          }
          .ticket-table th { padding: 8px 10px; font-size: 11px; }
          .ticket-table td { padding: 8px 10px; font-size: 12px; }

          /* Welcome bar */
          .welcome-bar {
            padding: 6px 10px;
            font-size: 11px;
          }

          /* Filter bar: stack filters */
          .filter-bar {
            flex-direction: row;
            flex-wrap: wrap;
            padding: 6px 10px;
            gap: 5px;
          }
          .filter-bar select, .filter-bar input[type="date"] {
            flex: 1 1 45%;
            min-width: 0;
          }
          .filter-group {
            flex: 1 1 45%;
          }

          /* Toggle buttons */
          .view-toggle-bar {
            padding: 6px 10px;
            gap: 6px;
          }
          .toggle-btn {
            padding: 6px 10px;
            font-size: 11px;
          }
        }

        @media only screen and (max-width: 360px) {
          .kanban-board { padding: 8px; gap: 10px; }
          .kanban-card strong { font-size: 12px; }
          .kanban-card p { font-size: 10px; }
          .toggle-btn { font-size: 10px; padding: 5px 8px; }
          .filter-bar select, .filter-bar input[type="date"] {
            flex: 1 1 100%;
          }
          .filter-group { flex: 1 1 100%; }
        }
      `}</style>

      {/* Welcome Bar */}
      <div className="welcome-bar">
        <span className="welcome-text">
          Welcome
          {userName && <span className="welcome-name">{userName.charAt(0).toUpperCase() + userName.slice(1).toLowerCase()}</span>}
          {!userName && "back!"}
        </span>
        <span style={{ fontSize: 12, opacity: 0.7 }}>Ticket Management Portal</span>
      </div>

      <Header
        title="Ticket Management"
        options={[
          { title: "Create Ticket", url: "/tickets/user/creating/" + sid + "/" + uid },
          { title: "Assigned Tickets", url: "/tickets/user/assigned_tickets/" + sid + "/" + uid },
        ]}
        ChangePage={(params) => history.push(params.url)}
      />

      {/* View Toggle */}
      <div className="view-toggle-bar">
        <button
          className={"toggle-btn " + (viewMode === "kanban" ? "active" : "")}
          onClick={() => { setViewMode("kanban"); closePanel(); }}
        >
          ⬜ Ticket Board
        </button>
        <button
          className={"toggle-btn " + (viewMode === "list" ? "active" : "")}
          onClick={() => { setViewMode("list"); closePanel(); }}
        >
          ☰ All Tickets (List View)
        </button>
      </div>

      {/* ── KANBAN VIEW ── */}
      {viewMode === "kanban" && (
        <div className="main-area">
          <div className="board-area">
            <div className="kanban-board">
              {[
                { label: "Open", items: open, color: "#2563eb" },
                //{ label: "In Progress", items: progress, color: "#d97706" },
                { label: "Closed", items: closed, color: "#16a34a" },
              ].map((col) => (
                <div className="kanban-column" key={col.label}>
                  <div className="kanban-col-header">
                    <span style={{ width: 10, height: 10, borderRadius: "50%", background: col.color, display: "inline-block", flexShrink: 0 }} />
                    <h3>{col.label}</h3>
                    <span className="col-count">{col.items.length}</span>
                  </div>
                  {col.items.map((d, i) => {
                    var isSelected = selectedTicket && selectedTicket.id === d.id;
                    return (
                      <div
                        key={i}
                        className={"kanban-card" + (isSelected ? " selected" : "")}
                        style={{ borderLeftColor: col.color }}
                        onClick={() => handleCardClick(d)}
                      >
                        <strong>{d.title}</strong>
                        <p>{d.description ? d.description.substring(0, 80) : ""}</p>
                        <div className="card-footer">
                          <span className="card-id">#{d.id}</span>
                          <span style={{ color: priorityColor(d.priority), fontWeight: 600 }}>
                            {d.priority || "—"}
                          </span>
                        </div>
                        {isSelected && (
                          <div className="click-hint">↩ Click again to open full details</div>
                        )}
                      </div>
                    );
                  })}
                  {col.items.length === 0 && (
                    <div style={{ textAlign: "center", color: "#9ca3af", fontSize: 12, padding: "20px 0" }}>
                      No tickets
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Right Detail Panel */}
          {selectedTicket && (
            <div className="detail-panel">
              <div className="panel-header">
                <div className="panel-header-left">
                  <div className="panel-ticket-id">#{selectedTicket.id}</div>
                  {/* Title as link → navigates to detail page */}
                  <span
                    className="panel-title-link"
                    onClick={() => history.push(detailUrl(selectedTicket.id))}
                    title="Open full ticket details"
                  >
                    {selectedTicket.title} ↗
                  </span>
                </div>
                <button className="panel-close" onClick={closePanel} title="Close panel">✕</button>
              </div>

              <div className="panel-body">
                <div className="panel-row">
                  <span className="panel-label">Status</span>
                  <span className="status-badge" style={{ background: statusColor(selectedTicket.status) }}>
                    {selectedTicket.status}
                  </span>
                </div>
                <div className="panel-row">
                  <span className="panel-label">Priority</span>
                  <span className="priority-badge" style={{ background: priorityColor(selectedTicket.priority) }}>
                    {selectedTicket.priority || "—"}
                  </span>
                </div>
                <div className="panel-row">
                  <span className="panel-label">School</span>
                  <span className="panel-value">
                    {selectedTicket.school_name || selectedTicket.schoolName || selectedTicket.school || "—"}
                  </span>
                </div>
                <div className="panel-row">
                  <span className="panel-label">Date</span>
                  <span className="panel-value">
                    {formatDate(selectedTicket.created_at || selectedTicket.createdAt || selectedTicket.date)}
                  </span>
                </div>
                {selectedTicket.assigned_to && (
                  <div className="panel-row">
                    <span className="panel-label">Assigned To</span>
                    <span className="panel-value">{selectedTicket.assigned_to}</span>
                  </div>
                )}
                <hr className="panel-divider" />
                <div className="panel-desc-label">Description</div>
                <div className="panel-desc">
                  {selectedTicket.description || "No description provided."}
                </div>
              </div>

              <span
                className="panel-open-btn"
                onClick={() => history.push(detailUrl(selectedTicket.id))}
              >
                Open Full Details →
              </span>
            </div>
          )}
        </div>
      )}

      {/* ── LIST VIEW ── */}
      {viewMode === "list" && (
        <>
          <div className="filter-bar">
            <div className="filter-group">
              <label>Status</label>
              <select value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
                <option>All</option>
                <option>Open</option>
                <option>In Progress</option>
                <option>Closed</option>
              </select>
            </div>
            <div className="filter-group">
              <label>School</label>
              <select value={filterSchool} onChange={(e) => setFilterSchool(e.target.value)}>
                {schoolNames.map((s) => <option key={s}>{s}</option>)}
              </select>
            </div>
            <div className="filter-group">
              <label>From</label>
              <input type="date" value={filterDateFrom} onChange={(e) => setFilterDateFrom(e.target.value)} />
            </div>
            <div className="filter-group">
              <label>To</label>
              <input type="date" value={filterDateTo} onChange={(e) => setFilterDateTo(e.target.value)} />
            </div>
            <button className="reset-btn" onClick={resetFilters}>✕ Reset</button>
            <button className="export-btn" onClick={exportToExcel}>
              ⬇ Export Excel ({filteredData.length})
            </button>
          </div>

          <div className="list-view-wrap">
            <div className="results-count">
              Showing <strong>{filteredData.length}</strong> of <strong>{data.length}</strong> tickets
            </div>
            <table className="ticket-table">
              <thead>
                <tr>
                  <th>#ID</th>
                  <th>Title</th>
                  <th>Description</th>
                  <th>Status</th>
                  <th>Priority</th>
                  <th>School</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length === 0 ? (
                  <tr>
                    <td colSpan={7}>
                      <div className="empty-state">No tickets match the selected filters.</div>
                    </td>
                  </tr>
                ) : (
                  filteredData.map((d, i) => (
                    <tr key={i}>
                      <td style={{ color: "#94a3b8", fontWeight: 600 }}>#{d.id}</td>
                      <td>
                        <span
                          className="ticket-title-link"
                          onClick={() => history.push(detailUrl(d.id))}
                        >
                          {d.title}
                        </span>
                      </td>
                      <td style={{ color: "#6b7280", maxWidth: 240 }}>
                        {d.description
                          ? d.description.substring(0, 100) + (d.description.length > 100 ? "…" : "")
                          : "—"}
                      </td>
                      <td>
                        <span className="status-badge" style={{ background: statusColor(d.status) }}>
                          {d.status}
                        </span>
                      </td>
                      <td>
                        <span className="priority-badge" style={{ background: priorityColor(d.priority) }}>
                          {d.priority || "—"}
                        </span>
                      </td>
                      <td>{d.school_name || d.schoolName || d.school || "—"}</td>
                      <td style={{ color: "#94a3b8", whiteSpace: "nowrap" }}>
                        {formatDate(d.created_at || d.createdAt || d.date)}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </>
      )}
    </>
  );
}
